// helpers/getTeamMembers.js
// AI-CONTEXT: See docs/features/agenda-role-colors.md
import { client } from "../hooks/Client";

const getTeamMembers = (team = [], personas = []) => {
  // Guard: als hooks nog niet geladen zijn
  if (!Array.isArray(team) || !Array.isArray(personas)) return [];

  const teamMembers = team
    .filter((m) => m?.ID)
    .map((member) => ({
      ID: member.ID,
      Name: member.UserName || "",
      Email: member.Email || "",
      Type: "team",
      // Role lives in the per-tenant map UserRoleIDs[client] — the flat
      // UserRoleID field is never written.
      Role: member.UserRoleIDs?.[client] || "",
    }));

  const personaMembers = personas
    .filter((p) => p?.ID)
    .map((persona) => ({
      ID: persona.ID,
      Name: persona.Name || "",
      Type: "persona",
      // Role references a UserRoles doc (the Rollen settings tab), not the traject.
      Role: persona.UserRoleID || "",
    }));

  return [...teamMembers, ...personaMembers];
};

export default getTeamMembers;
